const Steps = () => {
  const steps = [
    {
      number: '1',
      title: 'APPLY',
      description:
        'Click "Apply Now!" and complete a short form with your personal details and social media profiles.'
    },
    {
      number: '2',
      title: 'ONBOARD',
      description:
        "Once accepted, you'll receive a Partnership Kit with content guidelines and an exclusive discount code to book your free tour."
    },
    {
      number: '3',
      title: 'EXPLORE',
      description:
        'Experience an all-expenses-paid tour with a friend! Capture and share your adventure through engaging video content with your followers.'
    }
  ];

  return (
    <>
      <div className="flex justify-center items-center px-4 mt-12 sm:mt-0">
        <h1 className="text-primary font-bold text-[20px] md:text-[24px] lg:text-[40px] text-center">
          How Does It Work?
        </h1>
      </div>
      <div className="px-4 py-12 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map(step => (
            <div key={step.number} className="relative flex justify-center">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-12 h-12 flex items-center justify-center bg-[#FF3B4E] text-white rounded-full font-bold text-xl z-10">
                {step.number}
              </div>
              <div className="border-2 border-[#1E2959] rounded-3xl p-6 pt-8 h-auto min-h-[200px] md:h-[267px] lg:h-[307px] w-full md:w-[325px]">
                <h2 className="text-primary font-bold md:text-[20px] sm:text-[32px] lg:text-[35px] lg:mb-4 text-center mt-2">
                  {step.title}
                </h2>
                <p className="text-primary text-[14px] lg:text-[17px] leading-relaxed font-normal text-justify mt-3">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Steps;
